import React from "react";
import PropTypes from "prop-types";
import Button from "components/Common/Button";
import SvgIcon from "components/Common/SvgIcon";

const IntroScreen = ({
  gotoNextScreen,
  closeModal
}) => (
  <>
    <div className="Modal__content ZendeskAgentWorkspace__Intro">
      <h2>Before You Start</h2>
      <p>
        To ensure you are successful we recommend you have our setup guide
        and your Zendesk and Sunshine Conversations dashboard open during this process.
      </p>
      {/* TODO: Add actual link */}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        href=""
        target="_blank"
        rel="noopener noreferrer"
        className="ZendeskAgentWorkspace__Intro__popout-link"
      >
        <SvgIcon icon="PopOut" />
        <div>
          Open Zendesk Social Messaging Guide
        </div>
      </a>
    </div>
    <div
      className="Modal__bottom ZendeskAgentWorkspace__Intro__bottom"
    >
      <Button
        onClick={closeModal}
        text="Cancel"
        title="Cancel"
        customClassName="ZendeskAgentWorkspaceModal__cancel-button"
        light
      />
      <Button
        onClick={gotoNextScreen}
        text="Next"
        title="Next"
      />
    </div>
  </>
);

IntroScreen.propTypes = {
  gotoNextScreen: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default IntroScreen;
